import React, { Component } from 'react';

class IconNoContact extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="50.066" height="50.066" viewBox="0 0 50.066 50.066">
                <path id="Icon_awesome-phone-square-alt" data-name="Icon awesome-phone-square-alt" d="M44.7,2.25H5.364A5.364,5.364,0,0,0,0,7.614V46.952a5.364,5.364,0,0,0,5.364,5.364H44.7a5.364,5.364,0,0,0,5.364-5.364V7.614A5.364,5.364,0,0,0,44.7,2.25ZM42.87,36.6l-1.676,7.264a1.676,1.676,0,0,1-1.633,1.3A32.412,32.412,0,0,1,7.152,12.755a1.755,1.755,0,0,1,1.3-1.633l7.264-1.676a2.037,2.037,0,0,1,.377-.044,1.818,1.818,0,0,1,1.541,1.016l3.353,7.823a2,2,0,0,1,.135.66,1.9,1.9,0,0,1-.615,1.3l-4.234,3.464a25.917,25.917,0,0,0,12.38,12.38l3.464-4.234a1.9,1.9,0,0,1,1.3-.615,2,2,0,0,1,.66.135L41.9,34.683a1.816,1.816,0,0,1,1.016,1.541,1.946,1.946,0,0,1-.044.377Z" transform="translate(0 -2.25)" fill="#bcc7d8" />
            </svg>
        );
    }
}

export default IconNoContact;